module.exports = __webpack_public_path__ + "img/str_sj.fe766d2e.jpg";